import { useState, useEffect } from "react";
import Nav from "../Nav";
import Footer from "../Footer";
import "../styles/admin-management.scss";
import { Button } from "@mui/material";
import { Alert } from "@mui/material";
import { getAssetTypes, getAssetLocations } from "../../utils/utilsAPI";
import axios from "axios";

export default function AdminManagement() {
  const url = process.env.REACT_APP_URL;
  //Type & Locations
  const [locations, setLocations] = useState([]);
  const [types, setTypes] = useState([]);
  const [addAssetName, setAddAssetName] = useState("");
  const [selectedEditType, setSelectedEditType] = useState(0);
  const [editAssetType, setEditAssetType] = useState("");
  const [addLocationName, setAddLocationName] = useState("");
  const [selectedAssetLocation, setSelectedAssetLocation] = useState(0);
  const [editAssetLocation, setEditAssetLocation] = useState("");
  //Alerts
  const [addAssetAlert, setAddAssetAlert] = useState(false);
  const [editAssetAlert, setEditAssetAlert] = useState(false);
  const [addLocationAlert, setAddLocationAlert] = useState(false);
  const [editLocationAlert, setEditLocationAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);
  //Reload
  const [reload, setReload] = useState(false);

  useEffect(() => {
    //Bring in Asset Types
    getAssetTypes()
      .then((res) => {
        setTypes(res.assetTypes);
      })
      .catch((err) => {
        console.log(err);
      });
    //Bring in Locations
    getAssetLocations()
      .then((res) => {
        setLocations(res.locations);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [reload]);

  const handleAlert = (
    alert,
    message,
    severity,
    success = false,
    duration = 4000
  ) => {
    setMessage(message);
    setSeverity(severity);
    alert(true);
    setTimeout(() => {
      alert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (success) {
        setReload(!reload);
        clearFields();
      }
    }, duration);
  };

  const clearFields = () => {
    setAddAssetName("");
    setSelectedEditType(0);
    setEditAssetType("");
    setAddLocationName("");
    setSelectedAssetLocation(0);
    setEditAssetLocation("");
  };

  //! ADD TYPE CAN BE COMMENTED BACK IN BELOW IF REQUIRED
  // const handleAddType = async () => {
  //   setDisable(true);
  //   let reqBody = {
  //     currentUser: localStorage.getItem("userId"),
  //     assetName: addAssetName.trim(),
  //   };

  //   if (addAssetName === "") {
  //     handleAlert(
  //       setAddAssetAlert,
  //       "Please enter an asset type name",
  //       "warning"
  //     );
  //   } else {
  //     await axios
  //       .post(`${url}/assets/add-type`, reqBody)
  //       .then((res) => {
  //         handleAlert(setAddAssetAlert, "Asset Type Added", "success", true);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         handleAlert(
  //           setAddAssetAlert,
  //           "Something went wrong - please try again",
  //           "error"
  //         );
  //       });
  //   }
  // };

  const handleEditType = async () => {
    setDisable(true);
    let reqBody = {
      currentUser: localStorage.getItem("userId"),
      assetTypeId: selectedEditType,
      newType: editAssetType.trim(),
    };

    if (selectedEditType === 0) {
      handleAlert(setEditAssetAlert, "Please select an asset type", "warning");
    } else if (editAssetType === "") {
      handleAlert(
        setEditAssetAlert,
        "Please enter an asset type name",
        "warning"
      );
    } else {
      await axios
        .post(`${url}/assets/update-type`, reqBody)
        .then((res) => {
          handleAlert(setEditAssetAlert, "Asset Type Updated", "success", true);
        })
        .catch((err) => {
          console.log(err);
          handleAlert(
            setEditAssetAlert,
            "Something went wrong - please try again",
            "error"
          );
        });
    }
  };

  const handleAddLocation = async () => {
    setDisable(true);
    let reqBody = {
      currentUser: localStorage.getItem("userId"),
      assetLocation: addLocationName.trim(),
    };

    if (addLocationName === "") {
      handleAlert(setAddLocationAlert, "Please enter a location", "warning");
    } else {
      await axios
        .post(`${url}/assets/add-location`, reqBody)
        .then((res) => {
          handleAlert(
            setAddLocationAlert,
            "Asset location added",
            "success",
            true
          );
        })
        .catch((err) => {
          console.log(err);
          handleAlert(
            setAddLocationAlert,
            "Something went wrong - please try again",
            "error"
          );
        });
    }
  };

  const handleEditLocation = async () => {
    setDisable(true);
    let reqBody = {
      currentUser: localStorage.getItem("userId"),
      locationId: selectedAssetLocation,
      newLocation: editAssetLocation.trim(),
    };

    if (selectedAssetLocation === 0) {
      handleAlert(setEditAssetLocation, "Please select a location", "warning");
    } else if (editAssetLocation === "") {
      handleAlert(
        setEditAssetLocation,
        "Please enter a location name",
        "warning"
      );
    } else {
      await axios
        .post(`${url}/assets/update-location`, reqBody)
        .then((res) => {
          handleAlert(
            setEditLocationAlert,
            "Asset location updated",
            "success",
            true
          );
        })
        .catch((err) => {
          console.log(err);
          handleAlert(
            setEditLocationAlert,
            "Something went wrong - please try again",
            "error"
          );
        });
    }
  };

  return (
    <>
      <Nav />
      <main className="admin-management">
        <h1 className="page-header">
          Admin Managment {` - ${localStorage.getItem("username")}`}
        </h1>
        <section className="management-section">
          {/* <form>
            <h3>Add Asset Type</h3>
            <input
              placeholder="Enter Asset type"
              type="text"
              maxLength={50}
              value={addAssetName}
              onChange={(e) => setAddAssetName(e.target.value)}
            />
            <section className="alert-section">
              {addAssetAlert ? (
                <Alert severity={severity}>{message}</Alert>
              ) : null}
            </section>
            <Button
              variant="contained"
              color="success"
              className="submit-btn"
              disabled={disable}
              onClick={handleAddType}
            >
              Submit
            </Button>
          </form> */}
          <form>
            <h3>Update Asset Type</h3>
            <select
              value={selectedEditType}
              onChange={(e) => setSelectedEditType(parseInt(e.target.value))}
            >
              <option>Select a type</option>
              {types && types.length > 0
                ? types.map((t, i) => {
                    return (
                      <option key={i} value={t.assetTypeId}>
                        {t.assetType}
                      </option>
                    );
                  })
                : null}
            </select>
            <input
              placeholder="Enter new asset type"
              type="text"
              maxLength={50}
              value={editAssetType}
              onChange={(e) => setEditAssetType(e.target.value)}
            />
            <section className="alert-section">
              {editAssetAlert ? (
                <Alert severity={severity}>{message}</Alert>
              ) : null}
            </section>
            <Button
              variant="contained"
              color="warning"
              disabled={disable}
              onClick={handleEditType}
            >
              Update
            </Button>
          </form>
          <form>
            <h3>Add Asset Location</h3>
            <input
              placeholder="Enter asset location"
              type="text"
              maxLength={50}
              value={addLocationName}
              onChange={(e) => setAddLocationName(e.target.value)}
            />
            <section className="alert-section">
              {addLocationAlert ? (
                <Alert severity={severity}>{message}</Alert>
              ) : null}
            </section>
            <Button
              variant="contained"
              color="success"
              className="submit-btn"
              disabled={disable}
              onClick={handleAddLocation}
            >
              Submit
            </Button>
          </form>
        </section>
        <section className="management-section">
          <form>
            <h3>Update Asset Location</h3>
            <select
              value={selectedAssetLocation}
              onChange={(e) =>
                setSelectedAssetLocation(parseInt(e.target.value))
              }
            >
              <option>Please select a location</option>
              {locations && locations.length > 0
                ? locations.map((l, i) => {
                    return (
                      <option key={i} value={l.locationId}>
                        {l.locationName}
                      </option>
                    );
                  })
                : null}
            </select>
            <input
              placeholder="Enter location name"
              maxLength={50}
              type="text"
              value={editAssetLocation}
              onChange={(e) => setEditAssetLocation(e.target.value)}
            />
            <section className="alert-section">
              {editLocationAlert ? (
                <Alert severity={severity}>{message}</Alert>
              ) : null}
            </section>
            <Button
              variant="contained"
              color="warning"
              disabled={disable}
              onClick={handleEditLocation}
            >
              Update
            </Button>
          </form>
        </section>
      </main>
      <Footer />
    </>
  );
}
